import BaseView from './_BaseView.js';
import Dropdown from '../components/Dropdown.js';
import Table from '../components/Table.js';
import Confirm from "../components/Confirm";
import FileImport from "../components/FileImport";
import Api from "../Api";
import Notify from "../components/Notify";
import trans from "../util/trans";
import DOMPurify from "dompurify";
import Thinker from "../components/Thinker.js";

export default class ConfigView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#dynamicUrlForm';
        this.formUrl = '/api/urls';
        this.formTpl = 'dynamic-url-form';
        this.formTitle = Lang.addd;
        this.defaultObject = {
            prop: '',
            value: '',
        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    init() {
        const self = this;
        super.init();

        if ($('#pagedata').length > 0) {
            this.table = new Table('pagedata', '/api/urls/table', [
                {data: 'select', orderable: false},
                {data: 'description'},
                {data: 'prop'},
                {data: 'value'},
                {data: 'tools', orderable: false},
            ]);

            this.menu = new Dropdown('#configMenu', {
                onDelete: function (ids) {
                    if (ids.length > 0) {
                        //Confirm
                        Confirm({
                            ok: Lang.delete,
                            title: Lang.deleting,
                            msg: trans('deletex', ids.length),
                            onConfirm: function () {
                                self.deleteUrl(ids);
                            }
                        });
                    }
                },
                onExport: function (ids) {
                    const app = $('[data-app]').data('app');
                    window.location = `/api/urls/export?app=${app}&ids=${ids}`;
                }
            });

            const fileImport = new FileImport($('#import'), {
                url: '/api/urls/import',
                formTpl: 'import-file-form',
                title: Lang.urls,
                datalist: self.table
            });
            fileImport.init();

            $('.wysiwyg').trumbowyg();

            // load config values
            Api.send('/api/config').done(function (r) {
                $('[name="require"]').val(r.require);
                $('[name="username"]').val(r.username);
                $('[name="roles"]').val(r.roles);
                $('[name="fire"]').val(r.fire);
                if (r.alert) {
                    $('[name="alert"]').val(r.alert);
                }
                if (r.alertContent) {
                    $('[name="alertContent"]').trumbowyg('html', r.alertContent);
                }
                if (r.restrictTitle) {
                    $('[name="restrictTitle"]').val(r.restrictTitle);
                }
                if (r.restrictContent) {
                    $('[name="restrictContent"]').trumbowyg('html', r.restrictContent);
                }
                
                if (r.hasOwnProperty('appDefaults')) {
                    if(r.appDefaults['tipStyle'])
                    {
                        let id = r.appDefaults['tipStyle']??'default';
                        $(`#${id}`).attr('checked', 'checked');
                    }
                    for (let prop in r.appDefaults) {
                        if (r.appDefaults.hasOwnProperty(prop)) {
                            const $input = $('[name="' + prop + '"]');
                           
                            if (($input.attr('type') === 'checkbox' || $input.attr('type') === 'radio' )) {
                                if(prop != 'tipStyle')
                                {
                                    $input.prop('checked', !!(r.appDefaults[prop]));
                                }
                            } else {
                                $input.val(r.appDefaults[prop]);
                            }
                        }
                    }
                }
                $('#defaults input').trigger('change');
            });
        }

        if ($('#criteria').length > 0) {
            this.criteriaTable = new Table('criteria', '/api/criteria/table', [
                {data: 'name'},
                {data: 'parameter'},
                {data: 'expression'},
                {data: 'tools', orderable: false},
            ]);
        }

        if ($('#iconPreview').length > 0) {
            this.iconTable = new Table('iconPreview', `/api/icon/table?organization_id=${$('[data-org]').data('org')}`, [
                {data: 'content', orderable: false },
                {data: 'tools', orderable: false},
            ]);
        }

        if ($('#tipStylesTable').length > 0) {
            this.tipTable = new Table('tipStylesTable', `/api/apps/${$('[data-app]').data('app')}/tiptable`, [
                {data: 'name'},
                {data: 'tip', orderable: false},
                {data: 'tools', orderable: false},
            ]);
        }

        if ($('#consoleOptions').length > 0) {
            this.prepareOptions();
        }

        if ($('#workfrontRoles').length > 0) {
            this.workfrontTable = new Table('workfrontRoles', `/api/role/workfront/table`, [
                {data: 'title'},
                {data: 'description'},
                {data: 'workfront', orderable: false},
                {data: 'tools', orderable: false},
            ]);
        }
    }

    // TODO: move criteria stuff to it's own file

    renderCriteriaForm(criteria) {
        const self = this;
        let method, url;
        if (!criteria) {
            criteria = {
                name: '',
                expression: '',
                parameter: false
            };
            method = 'post';
            url = '/api/criteria';
        } else {
            method = 'patch';
            url = `/api/criteria/${criteria._id}`;
        }

        Api.getTpl('criteria-form').done(function (r) {
            const tpl = _.template(r);

            Confirm({
                ok: Lang.save,
                title: Lang.criteria,
                msg: tpl({item: criteria}),
                onValidate: function () {
                    return $('#criteriaForm').isFormValid();
                },
                onConfirm: function () {
                    const data = $('#criteriaForm').aeroSerialize();
                    data.parameter = !!(data.parameter);
                    Api.send(url, data, method).done(function () {
                        self.criteriaTable.reload();
                    });
                }
            });
        });
    }

    deleteUrl(ids) {
        const self = this;
        for (let i = 0, j = ids.length; i < j; i++) {
            Api.send(`/api/urls/${ids[i]}`, {}, 'delete').done(function () {
                self.table.reload();
            });
        }
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const urlContainer = $('#pagedataGroup');

        //Add
        urlContainer.off("click.dynurla").on("click.dynurla", '.add', function () {
            self.renderForm();
            return false;
        });

        //Delete
        urlContainer.off("click.dynurld").on("click.dynurld", ".delete", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr:eq(0)').find('td:eq(1)').text();

            //Confirm
            Confirm({
                ok: Lang.delete,
                title: name,
                msg: Lang.delsure,
                onConfirm: function () {
                    self.deleteUrl([id]);
                }
            });
            return false;
        });

        //Edit
        urlContainer.off("click.confige").on("click.confige", ".edit", function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/urls/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        $('.save-config').off("click.configs").on("click.configs", function () {
            const data = {};
            $(this).parents('form').find('textarea').each(function () {
                data[$(this).attr('name')] = $(this).val();
            });
            Api.send('/api/config', data, 'patch').done(function () {
                Notify(Lang.success, 'success', 600);
            });
            return false;
        });

        $('.save-defaults').off("click.sd").on("click.sd", function () {
            const data = {
                appDefaults: {}
            };
            $('#defaults .aero-label').each(function () {
                const input = $(this).find('input, select');
                let val = input.val();
                if (input.attr('type') === 'checkbox') {
                    val = input.prop('checked');
                }

                if (input.attr('type') !== 'radio') {
                    data.appDefaults[input.attr('name')] = val;
                } else if (input.attr('type') === 'radio' && input.prop('checked')) {
                    data.appDefaults[input.attr('name')] = val;
                }
            });
            Api.send('/api/config', data, 'patch').done(function () {
                Notify(Lang.success, 'success', 600);
            });
            return false;
        });

        $('#defaults input[name="useCustom"]').on('change', function () {
            if ($(this).prop('checked')) {
                $('.aero-custom-tip-style').show();
                $('.aero-tip-style-picker').hide();
            } else {
                $('.aero-custom-tip-style').hide();
                $('.aero-tip-style-picker').show();
            }
        });

        $('.reset-alert').on('click', function () {
            $(this).parents('form').trigger('reset');
            $('#alertContent').trumbowyg('html', $('#alertDefault').html());
            return false;
        });

        $('.reset-restrict').on('click', function () {
            $(this).parents('form').trigger('reset');
            $('#restrictContent').trumbowyg('html', $('#restrictDefault').html());
            return false;
        });

        $('.reset-defaults').on("click.rad", function () {
            $(this).parents('form').trigger('reset');
            return false;
        });

        $('.add-criteria').on('click', function () {
            self.renderCriteriaForm();
            return false;
        });

        $('#criteria').on('click', '.edit', function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/criteria/${id}`).done(function (r) {
                self.renderCriteriaForm(r);
            });
            return false;
        });

        $('#iconPreview').on('click', '.delete', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const icon = $(this).parents('tr').find('td:eq(0)').html();

            Confirm({
                ok: Lang.delete,
                title: Lang.icon,
                msg: `${Lang.delsure}<br>${icon}`,
                onConfirm: function () {
                    Api.send(`/api/icon/${id}`, {}, 'delete').done(() => {
                        self.iconTable.reload();
                    });
                }
            });
            return false;
        });

        $('#consoleOptions .save-console').on('click', function () {
            const data = $('#consoleOptions').aeroSerialize();
            data.hideTab = data.hideTab === '1' ? true : null;
            data.hidePathways = data.hidePathways === '1' ? true : null;
            data.rolemode = data.rolemode === '1' ? true : null;
            data.hideTeams = data.hideTeams === '1' ? true : null;
            data.hideAuthor = data.hideAuthor === '1' ? true : null;
            data.hideGuests = data.hideGuests === '1' ? true : null;
            data.useWelcome = data.useWelcome === '1' ? true : null;
            data.workfrontRoles = data.workfrontRoles === '1' ? true : null;
            Api.send(`/api/apps/${$('[data-app]').data('app')}/saveoptions`, data, 'post').done(function () {
                Notify(Lang.success, 'success', 600);
            });
        });

        $('input[name="hideTab"]').on('change', function () {
            if ($(this).prop('checked')) {
                $('.default-console').prop('checked', true).trigger('change');
                $('.whitelisting').hide();
            } else {
                $('.whitelisting').show();
            }
        });
        $('input[name="console"]').on('change', function () {
            if ($(this).prop('checked')) {
                const val = $(this).val();
                if (val === 'tab') {
                    $('.whitelist-tab').show();
                    $('.whitelist-custom').hide();
                } else if (val === 'element') {
                    $('.whitelist-custom').show();
                    $('.whitelist-element').show();
                    $('.whitelist-tab').hide();
                    $('.whitelist-badge').hide();
                } else if (val === 'badge') {
                    $('.whitelist-custom').show();
                    $('.whitelist-element').hide();
                    $('.whitelist-tab').hide();
                    $('.whitelist-badge').show();
                }
            }
        });
        $('#consoleOptions input[name="usecustom"]').on('change', function () {
            if ($(this).prop('checked')) {
                $('.whitelist-icon').show();
            } else {
                $('.whitelist-icon textarea').val('');
                $('.whitelist-icon').hide();
            }
        });

        $('#tipStylesTable').on('click', '.delete', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr:eq(0)').find('td:eq(0)').text();

            //Confirm
            Confirm({
                ok: Lang.delete,
                title: name,
                msg: Lang.delsure,
                onConfirm: function () {
                    Api.send(`/api/apps/${$('[data-app]').data('app')}/deletetip/${id}`, {}, 'delete').done(function () {
                        self.tipTable.reload();
                    });
                }
            });
            return false;
        });

        $('.change-theme').on('click', function () {
            Api.getTpl('change-theme').done(r => {
                const tpl = _.template(r);
                Confirm({
                    ok: Lang.settheme,
                    title: Lang.settheme,
                    msg: tpl(),
                    onConfirm: function () {
                        const url = `/api/apps/${$('[data-app]').data('app')}/savetheme`;
                        const data = { theme: $('#change-theme select').val()};
                        Api.send(url, data, 'post').done(r => {
                            $('.theme-name').html(r.themeName);
                        });
                    }
                });
            });
        });

        const buildRole = $('#buildRole');
        if (buildRole.length > 0) {
            $('.load-roles').on('click', this.buildRoles);
            $('.save-workfront-role').on('click', () => {
                this.saveRoles();
            });
        }

        $('.save-apikey').on('click', function () {
            if ($('#apiKey').isFormValid()) {
                const data = $('#apiKey').aeroSerialize();
                Api.send(`/api/apps/${$('[data-app]').data('app')}/apikey`, data, 'post').done( r => {
                    Notify('API Key saved', 'success', 600);
                });
            }
        });
    }

    prepareOptions() {
        Api.send(`/api/apps/${$('[data-app]').data('app')}`).done(function (r) {
            const options = r.consoleOptions;
            if (options) {
                $('#consoleOptions input, #consoleOptions textarea').each(function () {
                    if ($(this).attr('type') !== 'checkbox' && $(this).attr('type') !== 'radio') {
                        $(this).val(options[$(this).attr('name')]).trigger('change');
                    } else if ($(this).attr('type') === 'radio') {
                        if (options[$(this).attr('name')] === $(this).val()) {
                            $(this).prop('checked', true).trigger('change');
                        }
                    } else {
                        if (!!options[$(this).attr('name')]) {
                            $(this).prop('checked', true).trigger('change');
                        }
                    }
                });
                if ($('#consoleOptions textarea[name="icon"]').val() !== '') {
                    $('input[name="usecustom"]').prop('checked', true);
                }
                $('input[name="usecustom"]').trigger('change');
            } else {
                $('#consoleOptions input, #consoleOptions textarea').trigger('change');
            }
        });
    }

    buildRoles () {
        Thinker.think(() => new Promise(resolve => {
            Api.send(`/api/role/workfront`).done(r => {
                console.log('buildroles', r);
                // access levels
                const alSelect = $('select[name="al"]');
                alSelect.append('<option value="">- Ignore this value -</option>');
                for (let i = 0; i < r.al.length; i++) {
                    alSelect.append(DOMPurify.sanitize(`<option value="${r.al[i].ID}">${r.al[i].name}</option>`));
                }
                // home group
                const hgSelect = $('select[name="hg"]');
                hgSelect.append('<option value="">- Ignore this value -</option>');
                for (let i = 0; i < r.hg.length; i++) {
                    hgSelect.append(DOMPurify.sanitize(`<option value="${r.hg[i].ID}">${r.hg[i].name}</option>`));
                }
                // home team
                const htSelect = $('select[name="ht"]');
                htSelect.append('<option value="">- Ignore this value -</option>');
                for (let i = 0; i < r.ht.length; i++) {
                    htSelect.append(DOMPurify.sanitize(`<option value="${r.ht[i].ID}">${r.ht[i].name}</option>`));
                }
                // layout template
                const ltSelect = $('select[name="lt"]');
                ltSelect.append('<option value="">- Ignore this value -</option>');
                for (let i = 0; i < r.lt.length; i++) {
                    ltSelect.append(DOMPurify.sanitize(`<option value="${r.lt[i].ID}">${r.lt[i].name}</option>`));
                }
                // role
                const roSelect = $('select[name="ro"]');
                roSelect.append('<option value="">- Ignore this value -</option>');
                for (let i = 0; i < r.ro.length; i++) {
                    roSelect.append(DOMPurify.sanitize(`<option value="${r.ro[i].ID}">${r.ro[i].name}</option>`));
                }
                $('.load-roles').hide();
                $('.role-values').show();
                resolve();
            }).fail(r => {
                resolve();
            });
        }), $('#buildRole'));
    }

    saveRoles() {
        if ($('#buildRole').isFormValid()) {
            const self = this;

            const alSelect = $('select[name="al"]');
            const hgSelect = $('select[name="hg"]');
            const htSelect = $('select[name="ht"]');
            const ltSelect = $('select[name="lt"]');
            const roSelect = $('select[name="ro"]');

            const data = {
                app: $('[data-app]').data('app'),
                title: $('#buildRole input[name="title"]').val()

            };

            const workfront = [];
            const description = [];
            if (alSelect.val() !== '') {
                workfront.push(alSelect.val());
                description.push('Access Level: ' + alSelect.find('option:selected').text());
            }
            if (hgSelect.val() !== '') {
                workfront.push(hgSelect.val());
                description.push('Home Group: ' + hgSelect.find('option:selected').text());
            }
            if (htSelect.val() !== '') {
                workfront.push(htSelect.val());
                description.push('Home Team: ' + htSelect.find('option:selected').text());
            }
            if (ltSelect.val() !== '') {
                workfront.push(ltSelect.val());
                description.push('Layout Template: ' + ltSelect.find('option:selected').text());
            }
            if (roSelect.val() !== '') {
                workfront.push(roSelect.val());
                description.push('Role: ' + roSelect.find('option:selected').text());
            }

            if (workfront.length === 0) {
                $('#buildRole').prepend(`<div class="aero-error-box"><ul><li>You must select at least one criterion</li></ul></div>`);
                return false;
            }
            data.workfront = workfront.join('-');
            data.description = description.join(', ');
            Api.send(`/api/role/workfront`, data, 'post').done(r => {
                Notify('Role Created', 'success', 600);
                self.workfrontTable.reload();
            });
        }
    }
}
